// Resume49.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  Grid,
} from '@mui/material';
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
} from '@mui/icons-material';

const Resume49 = ({ color = "#303f9f" }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: '210mm',           // A4
          minHeight: '297mm',
          mx: 'auto',
          backgroundColor: 'white',
          p: { xs: 4, md: 6 },
          fontFamily: "'Times New Roman', Times, serif",
          color: '#1a1a1a',
          position: 'relative',     // for absolute bottom bar
        }}
      >
        {/* Header - Name & Title */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              letterSpacing: '1px',
              mb: 0.5,
              fontSize: '2.4rem',
              color: color,
            }}
          >
            SEBASTIAN BENNETT
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              color: color,
              fontSize: '1.35rem',
              letterSpacing: '0.5px',
            }}
          >
            Professional Accountant
          </Typography>
        </Box>

        {/* Contact Line */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 4,
            flexWrap: 'wrap',
            mb: 4,
            color: '#333',
            fontSize: '0.95rem',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
            <PhoneIcon fontSize="small" sx={{ color: color }} />
            <span>+123-456-7890</span>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
            <EmailIcon fontSize="small" sx={{ color: color }} />
            <span>hello@reallygreatsite.com</span>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
            <LocationOnIcon fontSize="small" sx={{ color: color }} />
            <span>123 Anywhere St., Any City</span>
          </Box>
        </Box>

        <Divider sx={{ borderColor: color, borderWidth: 1, my: 2.5 }} />

        {/* ABOUT ME */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: 1.2,
              letterSpacing: '0.4px',
              fontSize: '1.18rem',
              color: color,
            }}
          >
            ABOUT ME
          </Typography>
          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.65,
              fontSize: '0.96rem',
              color: '#222',
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
            ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          </Typography>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 3 }} />

        {/* EDUCATION */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: 1.5,
              letterSpacing: '0.4px',
              fontSize: '1.18rem',
              color: color,
            }}
          >
            EDUCATION
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', color: color }}>
              Borcelle University | 2026-2030
            </Typography>
            <Typography sx={{ fontWeight: 600, color: '#444', mb: 0.6 }}>
              Senior Accountant
            </Typography>
            <Typography sx={{ lineHeight: 1.6, fontSize: '0.95rem', color: '#222' }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
              ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
              ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', color: color }}>
              Borcelle University | 2023-2026
            </Typography>
            <Typography sx={{ fontWeight: 600, color: '#444', mb: 0.6 }}>
              Senior Accountant
            </Typography>
            <Typography sx={{ lineHeight: 1.6, fontSize: '0.95rem', color: '#222' }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
              ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
              ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 3 }} />

        {/* WORK EXPERIENCE */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: 1.5,
              letterSpacing: '0.4px',
              fontSize: '1.18rem',
              color: color,
            }}
          >
            WORK EXPERIENCE
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', color: color }}>
              Salford & Co. | 2033-2035
            </Typography>
            <Typography sx={{ fontWeight: 600, color: '#444', mb: 0.6 }}>
              Senior Accountant
            </Typography>
            <Typography sx={{ lineHeight: 1.6, fontSize: '0.95rem', color: '#222' }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
              ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
              ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>

        </Box>


      

        {/* Bottom accent bar */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '40px',
            backgroundColor: color,
            mt: 6,
          }}
        />
      </Paper>
    </Box>
  );
};

export const resumeMeta = {
  hasPhoto: false,
  columns: 1,
  colorOptions: [
    { value: "#303f9f", label: "Indigo" },
    { value: "#00796b", label: "Teal" },
    { value: "#d84315", label: "Deep Orange" },
    { value: "#6a1b9a", label: "Deep Purple" },
    { value: "#c62828", label: "Red" }
  ]
};

export default Resume49;